import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loader, Grid } from "@mantine/core";
import axios from "axios";
import { LoyaltyMembershipItem } from "./";
import { EmptyMessage } from "@components/shared";

export default function UserLoyaltyMemberships({ userId }) {
  const queryClient = useQueryClient();
  const {
    data: loyaltyMemberships = [],
    status,
    isLoading,
    isFetching,
    error,
  } = useQuery({
    queryKey: ["userLoyaltyMemberships", userId],
    retry: false,
    queryFn: async () =>
      axios
        .post(`/users/${userId}/loyalty-memberships/`, { user_id: userId })
        .then(({ data }) => {
          return data.response;
        })
        .catch((err) => {
          throw err;
        }),
    enabled: !!userId,
  });

  function fetchData() {
    queryClient.invalidateQueries({
      queryKey: ["userLoyaltyMemberships", userId],
    });
  }

  return (
    <div>
      {isLoading && <Loader size="xs" color="gray" />}
      {!isLoading && loyaltyMemberships.length === 0 && (
        <EmptyMessage
          title="No loyalty memberships"
          text="This user doesn't have any loyalty memberships."
        />
      )}
      {loyaltyMemberships.length > 0 && (
        <Grid>
          {loyaltyMemberships.map((membership) => (
            <Grid.Col span={{ base: 12, md: 6, lg: 4 }} key={membership.id}>
              <LoyaltyMembershipItem
                membership={membership}
                fetchData={() => {
                  fetchData();
                }}
              />
            </Grid.Col>
          ))}
        </Grid>
      )}
    </div>
  );
}
